import qs from 'qs';
import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    TopListsApiResponse,
    TopListsRequest
} from 'tradera/state/services/types/webapi-discover-generated';

export const tagTypes = { TopLists: 'TopLists' } as const;

export const topListsApi = createApi({
    reducerPath: 'topListsApi',
    baseQuery: isomorphicWebApiBaseQuery,
    tagTypes: Object.values(tagTypes),
    endpoints: (builder) => ({
        getTopLists: builder.query<TopListsApiResponse, TopListsRequest>({
            providesTags: [tagTypes.TopLists],
            query: ({ languageCodeIso2, automaticTranslationPreferred }) => {
                return `/discover/top-lists?${qs.stringify({
                    languageCodeIso2,
                    automaticTranslationPreferred
                })}`;
            },
            extraOptions: {
                getWishListableItems: (
                    topListsResponse: TopListsApiResponse
                ) => {
                    const items = [
                        ...(topListsResponse?.mostBiddedItems || []),
                        ...(topListsResponse?.mostExpensiveItems || []),
                        ...(topListsResponse?.mostWishListedItems || []),
                        ...(topListsResponse?.mostExpensiveSold || [])
                    ];
                    return items;
                }
            }
        })
    })
});

export const { useGetTopListsQuery, endpoints } = topListsApi;
